//@ts-ignore
import React,  { Component} from 'react';
import { Theme }  from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import MyPATVideoPlayer from './MyPatVideoPlayer';
import {
    WithStyles,
    createStyles,
    DialogContentText,
    DialogTitle,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
  } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    closePopup:{
        position:'absolute',
        top:'10px',
        right:'10px',
    },
    button: {
        margin: theme.spacing.unit,
      },
    mediaQuery: 
    { fullScreen : theme.breakpoints.down('sm')
    },
    title:{
        textAlign: 'center',
        borderBottom: "1px solid #efefef",
        padding: 15,
        marginBottom: 10,
        '& h6':{
            fontWeight: 700,
        }
    },
  });

  interface MyPatThumbnailProps extends WithStyles<typeof styles> {
    onCloseThumbnail: Function,
    open: boolean,
    thumbnailIcon: any,
    videoURL: string,
    setThumbnailURLAt: Function,
    getThumbnailURL: Function,
}

interface MyPatThumbnailState {
  
}

class MyPatThumbnail extends Component<MyPatThumbnailProps, MyPatThumbnailState>{
    render() {
        const { open, onCloseThumbnail, thumbnailIcon, videoURL, getThumbnailURL, classes } = this.props;
        
            return (
            <div>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                onClose={() => onCloseThumbnail()}
            >
                <DialogTitle className={classes.title} id="responsive-dialog-title">{"Custom Thumbnail"} 
                <IconButton aria-label="delete"
                onClick={() => onCloseThumbnail()}
                 className={classes.closePopup}
                >
                 <img  alt="Cance" src="/assets/svg/learn/closePanel.svg" />
                </IconButton>    
                </DialogTitle>     
                <DialogContent>
                <DialogContentText>
                    Scroll the bar to select a still from the video uploaded by you.
                </DialogContentText>
                <MyPATVideoPlayer 
                light = {true}
                controls = {false}
                slider={true}
                thumbnailIcon={thumbnailIcon}
                updateThumbnailTime={this.props.setThumbnailURLAt}
                videoURL={videoURL}
                />
                
                </DialogContent>
                <DialogActions>
                <Button autoFocus onClick={() => onCloseThumbnail()} color="primary">
                    Cancel
                </Button>
                <Button onClick={()=> {
                    onCloseThumbnail()
                    getThumbnailURL()
                }} color="primary"
                className={classes.button}
                variant="contained"
                 autoFocus>
                    Select
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        );
    }
}

// @ts-ignore
export default withStyles(styles)(MyPatThumbnail);